module.exports = __webpack_public_path__ + "dimer/static/img/8.6c332fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/8.jpg
// module id = UijE
// module chunks = 0